import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36994245"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comments" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-3 has-text-grey is-block" }, "Комментарии", -1))
const _hoisted_3 = { class: "comment-block" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "comment-help" }
const _hoisted_6 = { class: "comments-input" }
const _hoisted_7 = { class: "field has-addons" }
const _hoisted_8 = {
  class: "control",
  style: {"width":"100%"}
}
const _hoisted_9 = { class: "control" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fa-1x" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["mb-3 comments-wrapper with-scrollbar", {'busy': _ctx.ctx.isLoading}]),
      id: "comments-wrapper"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.list, (comment) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "comment-text",
            innerHTML: _ctx.decodeHtml(comment.text)
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, _toDisplayString(comment.user && comment.user.name ? comment.user.name : 'Неизвестно') + ", " + _toDisplayString(_ctx.$filters.dateTimeFromDateString(comment.created_at)), 1)
        ]))
      }), 256))
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("input", {
            class: "input",
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.typing && _ctx.typing(...args)))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "button is-warning",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
          }, _hoisted_11)
        ])
      ])
    ])
  ]))
}